import React, { useEffect, useMemo, useRef, useState } from "react";
import { CircularProgress, Grid } from "@material-ui/core";
import Unauthorize from "../../../pages/Unauthorize";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import UserApi from "../../services/api/user";
import PaymentContainerIn from "./IN/invoice-view";
import PaymentView from "../../templates/payment-view";
import PaymentContainerLk from "./LK";
import PaymentContainerLkOld from "./LK-old";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Config from "../../config";
import withLanguageMigrator from "../../hoc/language-migrator";
import { isEmptyOrNullOrUndefined, scrollToTop } from "../../utils";
import DeprecationHandler from "../../utils/deprecation-handler";
import RouteConfigHandler from "../../templates/route-config-handler";
import { NEW_PRICING_TIERS } from "../../static-data";

const { CURRENT_PLATFORM, PLATFORMS } = Config;

export const PRICING_VERSIONS = {
  VERSION_1: "VERSION_1",
  VERSION_2: "VERSION_2",
};

const PaymentForAd = ({ routeId, lng }) => {
  const { authAccount, authProfile, initialized, authenticated, appConfig } =
    useSelector((state) => state.application);

  const [advertisement, setAdvertisement] = useState({});
  const [pricingVersion, setPricingVersion] = useState("");
  const headingContainerRef = useRef(null);

  const history = useHistory();

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    if (isEmpty(authAccount)) {
      return;
    }

    const operatorRoles = [
      Config.USER_ROLES.OPERATOR,
      Config.USER_ROLES.OPERATOR_L2,
    ];

    if (operatorRoles.includes(authAccount.role)) {
      const postId = localStorage.getItem("postId");
      if (postId !== null) {
        UserApi.getOperatorManagedProfile({ postId }).then((response) => {
          if (!response.success) {
            return; // TODO: Error Handling
          }
          setAdvertisement(response.body[0] ?? {});
        });
      }
    } else {
      setAdvertisement(authProfile);
    }
  }, [authAccount, authProfile]);

  const isRenewProfile = useMemo(() => {
    const renewalProfileStatus = ["EXPIRED", "LIVE"];
    const output =
      !isEmpty(advertisement) &&
      renewalProfileStatus.includes(advertisement.status);
    sessionStorage.setItem("isRenew", output);
    return output;
  }, [advertisement]);

  const eligibleToPurchase = useMemo(() => {
    if (isEmpty(advertisement)) {
      return false;
    }
    const paymentEligibleStatus = ["PAYMENT_PENDING", "LIVE", "EXPIRED"];
    return paymentEligibleStatus.includes(advertisement.status);
  }, [advertisement]);

  const displayNewPayment = useMemo(() => {
    let newPricing_enabled = true;
    const configData = appConfig.appConfig;

    if (!isEmptyOrNullOrUndefined(configData)) {
      const config =
        configData.find((element) => element.id === "new_pricing") ?? {};
      newPricing_enabled = config.enabled ?? true;
    }

    if (!newPricing_enabled) {
      return false;
    }

    let output = true;

    if (!isEmpty(advertisement)) {
      if (!isEmptyOrNullOrUndefined(advertisement.firstPublishedAt)) {
        const pricingTier = advertisement.pricingTier;
        output = isEmptyOrNullOrUndefined(pricingTier)
          ? false
          : NEW_PRICING_TIERS.includes(pricingTier.id);
      } else {
        output = true;
      }
    }
    return output;
  }, [advertisement, appConfig]);

  useEffect(() => {
    if (displayNewPayment) {
      setPricingVersion(PRICING_VERSIONS.VERSION_2);
    } else {
      setPricingVersion(PRICING_VERSIONS.VERSION_1);
    }
  }, [displayNewPayment]);

  useEffect(() => {
    if (initialized && authenticated && isEmpty(authProfile)) {
      history.push("/complete-ad-personal");
    }
  }, [initialized, authenticated, authProfile, history]);

  if (!DeprecationHandler.isAuthAuthorized()) {
    return <Unauthorize title="Payment Invoice | Poruwa.lk" />;
  }

  if (initialized && !eligibleToPurchase) {
    return (
      <PaymentView
        advertisementId={advertisement.memberId}
        advertisementStatus={advertisement.status}
      />
    );
  }

  let contentTopMargin = 50;
  if (headingContainerRef.current !== null) {
    const headingContainer = headingContainerRef.current;
    const boundingRectangle = headingContainer.getBoundingClientRect();
    contentTopMargin = Math.ceil(boundingRectangle.height);
  }

  return (
    <RouteConfigHandler id={routeId}>
      {(!initialized || isEmpty(pricingVersion)) && (
        <Grid container justifyContent="center" className="margin-top-24">
          <CircularProgress style={{ color: "#cca326" }} />
        </Grid>
      )}

      {initialized && CURRENT_PLATFORM === PLATFORMS.IN && (
        <PaymentContainerIn />
      )}

      {initialized && CURRENT_PLATFORM === PLATFORMS.LK && (
        <>
          {pricingVersion === PRICING_VERSIONS.VERSION_1 && (
            <PaymentContainerLkOld
              lng={lng}
              contentTopMargin={contentTopMargin}
              isRenewProfile={isRenewProfile}
              headingContainerRef={headingContainerRef}
              setPricingVersion={setPricingVersion}
            />
          )}
          {pricingVersion === PRICING_VERSIONS.VERSION_2 && (
            <PaymentContainerLk
              setPricingVersion={setPricingVersion}
              displayNewPayment={displayNewPayment}
            />
          )}
        </>
      )}
    </RouteConfigHandler>
  );
};

export default withLanguageMigrator(PaymentForAd);
